import { useContext } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import { FlyoutTitleContext } from './FlyoutContext';

const FlyoutTitle = ({ children }) => {
  const ref = useContext(FlyoutTitleContext);
  return ref && ref.current ? createPortal(children, ref.current) : null;
};

FlyoutTitle.propTypes = {
  children: PropTypes.node,
};

export default FlyoutTitle;
